import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { hasPermission } from '../../utils/permissions';
import {
  retainPhmLiveBackgroundSync,
  releasePhmLiveBackgroundSync
} from './phmLiveSessionCache';

/**
 * Mounted globally (see App.js): keeps the shared PHM live cache warm on every route for any
 * authenticated user with phm.access, so navigating away to Admin Panel / Break Scheduler and back
 * to Productive Hours shows current data immediately. Renders nothing; self-gates on permission.
 */
const PhmLivePrefetch = () => {
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    const enabled = isAuthenticated && user && hasPermission(user, 'phm.access');
    if (!enabled) return undefined;
    retainPhmLiveBackgroundSync();
    return () => releasePhmLiveBackgroundSync();
  }, [isAuthenticated, user]);

  return null;
};

export default PhmLivePrefetch;
